import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { colors, font } from '../../design/tokens'
import { BotonPrimario } from './comunes'
import { useAccesoMovil } from './accesoMovil'

// Home de la versión móvil: lanzador de las secciones. Desde acá también se
// arranca una venta nueva (la acción más frecuente del vendedor en la calle).
const SECCIONES = [
  { id: 'ventas',    icono: '🧾', titulo: 'Ventas',    desc: 'Notas de venta — crear, procesar y seguir', to: '/m/ventas' },
  { id: 'clientes',  icono: '👥', titulo: 'Clientes',  desc: 'Historia y deudores', to: '/m/clientes' },
  { id: 'whatsapp',  icono: '💬', titulo: 'WhatsApp',  desc: 'Bandeja de conversaciones — leer y responder', to: '/m/whatsapp' },
  { id: 'logistica', icono: '📦', titulo: 'Logística', desc: 'Remitos y notas de envío', to: '/m/logistica' },
  { id: 'reparto',   icono: '🚚', titulo: 'Reparto',   desc: 'Salidas en calle y entregas', to: '/m/reparto' },
  { id: 'tablero',   icono: '🚦', titulo: 'Tablero',   desc: 'Entregas: éxito, fallos y pendientes', to: '/m/tablero' },
  { id: 'resenas',   icono: '⭐', titulo: 'Reseñas',   desc: 'Cómo nos puntúan los clientes', to: '/m/resenas' },
  { id: 'wineclub',  icono: '🍷', titulo: 'Wine Club', desc: 'Niveles y precios de las membresías', to: '/m/wine-club' },
  { id: 'fotos',     icono: '📸', titulo: 'Fotos',     desc: 'Escaneá el código y sacá la foto del producto', to: '/m/fotos' },
  { id: 'conteo',    icono: '🔢', titulo: 'Conteo',    desc: 'Inventario: escaneá y cargá lo que contaste', to: '/m/conteo' },
  { id: 'experiencia', icono: '🎟', titulo: 'Experiencias', desc: 'Invitados, confirmaciones y nueva experiencia', to: '/m/experiencias' },
]

const ROLES_BI = ['administrador', 'super_administrador']

export default function MovilHome() {
  const navigate = useNavigate()
  const { user, hasAnyRole, rolOperativoVentas } = useAuth()
  const nombre = (user?.nombre || '').split(' ')[0]
  // Cada tarjeta aparece solo si el menú (por rol y por persona) le da esa
  // sección — misma regla que la compu (accesoMovil.jsx).
  const { puede } = useAccesoMovil()
  const verReportes = puede('/m/reportes')
  const verConsultas = puede('/m/consultas-stock')

  return (
    <div>
      <div style={{ margin: '6px 0 14px' }}>
        <h1 style={{ margin: 0, fontSize: 22, fontFamily: font.sans, color: colors.text }}>
          {nombre ? `Hola, ${nombre}` : 'LGR móvil'}
        </h1>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: colors.textSec, fontFamily: font.sans }}>
          LGR en el celular — ventas, clientes y entregas
        </p>
      </div>

      {rolOperativoVentas() && puede('/m/ventas/nueva') && (
        <BotonPrimario onClick={() => navigate('/m/ventas/nueva')} style={{ marginBottom: 12 }}>
          ＋ Nueva venta
        </BotonPrimario>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {SECCIONES.filter((s) => puede(s.to)).map((s) => (
          <button key={s.id} onClick={() => navigate(s.to)} style={cardBtn}>
            <span style={{ fontSize: 26, width: 34, textAlign: 'center', flexShrink: 0 }}>{s.icono}</span>
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={{ display: 'block', fontFamily: font.sans, fontWeight: 600, fontSize: 16, color: colors.text }}>{s.titulo}</span>
              <span style={{ display: 'block', fontSize: 12.5, color: colors.textSec, fontFamily: font.sans }}>{s.desc}</span>
            </span>
            <span style={{ color: colors.textMeta, fontSize: 20, flexShrink: 0 }}>›</span>
          </button>
        ))}
      </div>

      {verConsultas && (
        <button onClick={() => navigate('/m/consultas-stock')} style={{ ...cardBtn, marginTop: 10 }}>
          <span style={{ fontSize: 26, width: 34, textAlign: 'center', flexShrink: 0 }}>🏬</span>
          <span style={{ flex: 1, minWidth: 0 }}>
            <span style={{ display: 'block', fontFamily: font.sans, fontWeight: 600, fontSize: 16, color: colors.text }}>Consultas de stock</span>
            <span style={{ display: 'block', fontSize: 12.5, color: colors.textSec, fontFamily: font.sans }}>Responder a Ventas y avisar stock bajo</span>
          </span>
          <span style={{ color: colors.textMeta, fontSize: 20, flexShrink: 0 }}>›</span>
        </button>
      )}

      {verReportes && (
        <button onClick={() => navigate('/m/reportes')} style={{ ...cardBtn, marginTop: 10 }}>
          <span style={{ fontSize: 26, width: 34, textAlign: 'center', flexShrink: 0 }}>📊</span>
          <span style={{ flex: 1, minWidth: 0 }}>
            <span style={{ display: 'block', fontFamily: font.sans, fontWeight: 600, fontSize: 16, color: colors.text }}>Reportes</span>
            <span style={{ display: 'block', fontSize: 12.5, color: colors.textSec, fontFamily: font.sans }}>Temporada y otros reportes de ventas, al día</span>
          </span>
          <span style={{ color: colors.textMeta, fontSize: 20, flexShrink: 0 }}>›</span>
        </button>
      )}

      {puede('/m/precios-ml') && (
        // Solo el super admin (Martin, 29 sep 2026: "solo yo").
        <button onClick={() => navigate('/m/precios-ml')} style={{ ...cardBtn, marginTop: 10 }}>
          <span style={{ fontSize: 26, width: 34, textAlign: 'center', flexShrink: 0 }}>🏷</span>
          <span style={{ flex: 1, minWidth: 0 }}>
            <span style={{ display: 'block', fontFamily: font.sans, fontWeight: 600, fontSize: 16, color: colors.text }}>Precios ML</span>
            <span style={{ display: 'block', fontSize: 12.5, color: colors.textSec, fontFamily: font.sans }}>Escaneá un código y compará con MercadoLibre</span>
          </span>
          <span style={{ color: colors.textMeta, fontSize: 20, flexShrink: 0 }}>›</span>
        </button>
      )}

      <div style={{ marginTop: 22, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {hasAnyRole(ROLES_BI) && (
          <button onClick={() => navigate('/panel')} style={linkBtn}>📈 Panel de BI (dirección)</button>
        )}
        <button onClick={() => navigate('/dashboard')} style={linkBtn}>🖥 Ir a LGR completo</button>
      </div>
    </div>
  )
}

const cardBtn = {
  display: 'flex', alignItems: 'center', gap: 14, textAlign: 'left',
  padding: '16px 16px', borderRadius: 14, border: `1px solid ${colors.border}`,
  background: colors.bg, cursor: 'pointer', width: '100%',
}
const linkBtn = {
  padding: '11px 0', borderRadius: 12, border: `1px solid ${colors.border}`,
  background: colors.bg, color: colors.textSec, fontSize: 13, fontWeight: 600,
  fontFamily: font.sans, cursor: 'pointer', width: '100%',
}
